export const FIELD_ARRAY_TICKET_LIST = [{ fieldName: 'Date', type: 'date', key: 'Date', keyType: 'singleKey', icon: 'DESC', shouldDisplay: true }, { fieldName: 'Ticket No', type: 'status hyper-linked description', keyType: 'multipleKeys', key: ['status', 'TicketNo', 'description'], icon: 'DESC', shouldDisplay: true }, { fieldName: 'Asset Name', type: 'object', key: 'assetTypes', keyType: 'singleKey', icon: 'DESC', shouldDisplay: true }, { fieldName: 'Status', type: 'color-coded', key: 'Status', keyType: 'singleKey', icon: 'DESC', shouldDisplay: true }, { fieldName: 'Ticket Raised by', type: 'has multiple values', key: ['UserName', 'UserEmail'], keyType: 'multipleKeys', icon: 'DESC', shouldDisplay: true }, { fieldName: 'Ticket Assigned to', type: 'has multiple values', key: ['AssigneeName', 'AssigneEmail'], keyType: 'multipleKeys', icon: 'DESC', shouldDisplay: true }]
export const FIELD_ARRAY_FOR_CLOSED_TICKETS = [{ fieldName: 'Date', type: 'date', key: 'Date', keyType: 'singleKey', icon: 'DESC' }, { fieldName: 'Ticket No', type: 'status hyper-linked description', keyType: 'multipleKeys', key: ['status', 'TicketNo', 'description'], icon: 'DESC' }, { fieldName: 'Asset Name', type: 'string', key: 'assetTypes', keyType: 'singleKey', icon: 'DESC' }, { fieldName: 'Ticket Status', key: 'ticketSubStatus', type: 'string', keyType: 'singleKey', icon: 'DESC' }, { fieldName: 'Ticket Raised by', type: 'has multiple values', key: ['UserName', 'UserEmail'], keyType: 'multipleKeys', icon: 'DESC' }, { fieldName: 'Ticket Assigned to', type: 'has multiple values', key: ['AssigneeName', 'AssigneEmail'], keyType: 'multipleKeys', icon: 'DESC' }]
export const FIELD_ARRAY_REQUEST_LIST = [{ fieldName: 'Date', type: 'date', key: 'Date', keyType: 'singleKey', icon: 'DESC', shouldDisplay: true }, { fieldName: 'Ticket No', type: 'status hyper-linked description', keyType: 'multipleKeys', key: ['status', 'TicketNo', 'description'], icon: 'DESC', shouldDisplay: true }, { fieldName: 'Asset Name', type: 'string', key: 'assetTypes', keyType: 'singleKey', icon: 'DESC', shouldDisplay: true }, { fieldName: 'Priority', type: 'color-coded', key: 'Priority', keyType: 'singleKey', icon: 'DESC', shouldDisplay: true }, { fieldName: 'Request Raised by', type: 'has multiple values', key: ['UserName', 'UserEmail'], keyType: 'multipleKeys', icon: 'DESC', shouldDisplay: true }, { fieldName: 'Request Assigned to', type: 'has multiple values', key: ['AssigneeName', 'AssigneEmail'], keyType: 'multipleKeys', icon: 'DESC', shouldDisplay: true }]
export const FIELD_ARRAY_APPROVAL_LIST = [{ fieldName: 'Date', type: 'date', key: 'Date', keyType: 'singleKey', icon: 'DESC', shouldDisplay: true }, { fieldName: 'TicketNo', type: 'status hyper-linked description', keyType: 'multipleKeys', key: ['status', 'TicketNo', 'description'], icon: 'DESC', shouldDisplay: true }, { fieldName: 'Ticket Status', type: 'color-coded', key: 'ticketStatus', keyType: 'singleKey', icon: 'DESC', shouldDisplay: true }, { fieldName: 'Approval Status', type: 'color-coded', key: 'finalStatus', keyType: 'singleKey', icon: 'DESC', shouldDisplay: true }, { fieldName: 'Ticket Raised By', type: 'has multiple values', key: ['createdBy', 'createdByEmail'], keyType: 'multipleKeys', icon: 'DESC', shouldDisplay: true }, { fieldName: 'Ticket Assigned To', type: 'has multiple values', key: ['assignedTo', 'assignedToEmail'], keyType: 'multipleKeys', icon: 'DESC', shouldDisplay: true }]
export const FIELD_ARRAY_WORKSPACE_LIST = [{ fieldName: 'Workspace Name', type: 'hyper-linked', key: 'name', keyType: 'singleKey', icon: 'DESC', shouldDisplay: true }, {
    fieldName: 'Plan Name',
    type: 'text',
    key: 'planName',
    keyType: 'singleKey',
    icon: 'DESC',
    shouldDisplay: true,
},
{
    fieldName: 'Start Date',
    type: 'date',
    key: 'startDate',
    keyType: 'singleKey',
    icon: 'DESC',
    shouldDisplay: true,
},
{
    fieldName: 'End Date',
    type: 'date',
    key: 'endDate',
    keyType: 'singleKey',
    icon: 'DESC',
    shouldDisplay: true,
}
];
export const FIELD_ARRAY_PROJECTS_LIST = [
    {
        fieldName: 'Client',
        type: 'text',
        key: 'clientName',
        keyType: 'singleKey',
        icon: 'DESC',
        shouldDisplay: true,
    },
    {
        fieldName: 'Projects',
        type: 'text',
        key: 'name',
        keyType: 'singleKey',
        icon: 'DESC',
        shouldDisplay: true,
    },
    {
        fieldName: 'Assets Linked',
        type: 'number',
        key: 'assetLinked',
        keyType: 'singleKey',
        icon: 'DESC',
        shouldDisplay: true,
    },
    {
        fieldName: 'Added By',
        type: 'text',
        key: 'createdByUser',
        keyType: 'singleKey',
        icon: 'DESC',
        shouldDisplay: true,
    },
    {
        fieldName: 'Added On',
        type: 'date',
        key: 'createdOn',
        keyType: 'singleKey',
        icon: 'DESC',
        shouldDisplay: true,
    },
    {
        fieldName: 'Actions',
        type: 'action-icons',
        key: 'actions',
        keyType: 'singleKey',
        icon: '',
        shouldDisplay: true,
    },
];
export const FIELD_ARRAY_CLIENTS_LIST = [
    {
    fieldName: 'Added On',
    type: 'date',
    key: 'createdAt',
    keyType: 'singleKey',
    icon: 'DESC',
    shouldDisplay: true,
  },
  {
    fieldName: 'Client Name',
    type: 'text',
    key: 'name',
    keyType: 'singleKey',
    icon: 'DESC',
    shouldDisplay: true,
  },
  {
    fieldName: 'Added By',
    type: 'text',
    key: 'createdby', 
    keyType: 'singleKey',
    icon: 'DESC',
    shouldDisplay: true,
  },
  {
    fieldName: 'Actions',
    type: 'action-icon',
    key: 'editClient',
    keyType: 'singleKey',
    icon: '',
    shouldDisplay: true,
  },
];
